import React, {lazy, Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {Provider} from 'react-redux';
import Store from './redux/Store';
import {AbilityContext} from './utility/context/Can';
import ability from './configs/acl/ability';
import {ThemeContext} from './utility/context/ThemeColors';
import {ToastContainer} from 'react-toastify';
import './assets/fonts/feather/iconfont.css';
import './scss/core.scss';
import './assets/scss/style.scss';
import Spinner from './components/spinner/Fallback-spinner';
import ErrorBoundary from './components/errorBoundary/ErrorBoundary';
import './configs/i18n';
import 'react-perfect-scrollbar/dist/css/styles.css';
import '@styles/react/libs/toastify/toastify.scss';

// Network/HTTP failures are operational, not programming errors: useHttpRequest
// already surfaces them as toasts. Some callers don't .catch() the rejected
// promise, which would otherwise trip the dev error overlay (and spam the
// console in production). Swallow only axios-shaped rejections here so genuine
// code bugs still surface.
const isAxiosLikeRejection = (reason: any): boolean =>
    !!reason && (reason.isAxiosError === true || reason.config !== undefined);

window.addEventListener('unhandledrejection', (event) => {
    if (isAxiosLikeRejection(event.reason)) {
        event.preventDefault();
    }
});

const LazyApp = lazy(() => import('./App'));

ReactDOM.render(
    <Provider store={Store}>
        <Suspense fallback={<Spinner />}>
            <AbilityContext.Provider value={ability}>
                <ThemeContext>
                    <ErrorBoundary>
                        <LazyApp />
                    </ErrorBoundary>
                    <ToastContainer newestOnTop />
                </ThemeContext>
            </AbilityContext.Provider>
        </Suspense>
    </Provider>,
    document.getElementById('root')
);
